import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import venueService from "@/services/api/venues";
import type { Venue, GetVenuesParams } from "@/services/api/venues";

export interface VenueState {
  venues: Venue[];
  totalVenues: number;
  isFetching: boolean;
  error: string | null;
}

const initialState: VenueState = {
  venues: [],
  totalVenues: 0,
  isFetching: false,
  error: null,
};

export const getVenues = createAsyncThunk(
  "venue/getVenues",
  async (params: GetVenuesParams | undefined) => venueService.getVenues(params),
);

const venueSlice = createSlice({
  name: "venue",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVenues.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(getVenues.fulfilled, (state, action) => {
        state.isFetching = false;
        state.venues = action.payload?.data?.results ?? [];
        state.totalVenues = action.payload?.data?.totalRecord ?? state.venues.length;
      })
      .addCase(getVenues.rejected, (state, action) => {
        state.isFetching = false;
        state.venues = [];
        state.error = action.error.message ?? "Failed to load venues";
      });
  },
});

export default venueSlice.reducer;
